import React, {Component} from 'react';
import logo from "./assets/sonol-logo.png";
import sonolImage from "./assets/sonol-circle.png";
import giftImage from "./assets/gift-circle.png";
import SignupForm from "./SignupForm";

class Signup extends Component {
    render() {
        return (
            <div className="gradient-container text-center">
                <img className="logo-wrapper" src={logo} alt="סונול"/>
                <div className="white-container mx-auto">
                    <h2 className="welcome-header">ברוכים הבאים <br/> למועדון הלקוחות של סונול</h2>
                    <div className="goods-gifts">
                        <img className="sonol-image" src={sonolImage} alt=""/>
                        <img className="gift-image" src={giftImage} alt=""/>
                    </div>
                    <div className="image-description">
                        <span className="sonol-description">צוברים goods</span>
                        <span className="gift-description">מקבלים הטבות שוות</span>
                    </div>
                    <SignupForm/>
                </div>
            </div>
        );
    }
}

export default Signup;


// WEBPACK FOOTER //
// ./src/Signup.js